import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Avatar } from 'primeng/avatar';
import { DownloadTemplateComponent } from './components/download-template/download-template.component';
import { UploadHeadingComponent } from './components/upload-heading/upload-heading.component';
import { ImportFileComponent } from './components/import-file/import-file.component';
import { FaqComponent } from './components/faq/faq.component';

@Component({
  selector: 'app-upload',
  imports: [
    TranslatePipe,
    DownloadTemplateComponent,
    UploadHeadingComponent,
    ImportFileComponent,
    FaqComponent,
  ],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
})
export class UploadComponent {
  public translationPrefix = 'upload.';
}
